module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile-404@3x_6efc29.jpg";